import { validatePlatformContent } from "utils/newMediaValidation";


/**
 * Validates TikTok post content and media
 * @param {Object} params - The parameters for validation
 * @param {String} params.caption - The post caption
 * @param {String} params.privacy_level - The privacy level of the post
 * @param {Array} params.mediaList - Media files for the post
 * @param {Number} params.monthlyPosts - Available monthly posts
 * @param {Object} params.fileLimits - File limits for different platforms
 * @returns {Boolean} - Whether the post has validation errors
 */
const validateTiktok = ({
  caption,
  privacy_level,
  mediaList,
  monthlyPosts,
}) => {
  const errorList = [];

  const { platformErrors, mediaList: mediaListValidated } =
    validatePlatformContent({
      mediaListRaw: mediaList,
      platform: "tiktok",
      caption,
    });

  errorList.push(
    platformErrors.length > 0 ||
      mediaListValidated.some((media) => media.errors.length > 0)
  );
  errorList.push(!privacy_level);
  errorList.push(monthlyPosts < 1);

  return errorList.includes(true);
};

export default validateTiktok;
